module.exports = __webpack_public_path__ + "img/browser-face.ae32042e.svg";